import React from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import { pdfCustomToolbarGenerator } from '../../../../models/tools/generarPdf'
import StockListado from '../../../../models/stock/stock_listado'
import MovimientosExportador from '../../../../models/stock/movimientos_exportador'
import * as TABLAS from '../../../../config/tables'
import * as COLUMNAS from './constantes'
import { parseEntityId } from '../../../../models/entity'
import { change, getFormValues } from 'redux-form'
import { Col } from 'react-bootstrap'
import OpcionesCerealEstimacion from '../../components/estimacionStock/OpcionesCerealEstimacion'
import { FORM_ESTIMACION_STOCK, FORM_TRANSFERENCIAS_EXPORTADOR } from '../../../../config/forms'
import ProyeccionStock from '../../../../models/stock/proyeccionStock'
import { COLORES } from '../../../../config/colores'
import ErrorIcon from '@material-ui/icons/Error'
import ParametroInteger from '../../../../models/parametro/parametro_integer'
import { getCuposVigentes, saveCuposVigentes } from '../../../Cupos/actions'
import MovimientosTerminal from '../../../../models/stock/movimientos_terminal'

const stockListado = new StockListado()
const proyeccionStock = new ProyeccionStock()
const movimientosExportador = new MovimientosExportador()
const movimientosTerminal = new MovimientosTerminal()

export function parseData (data, fechaD = null, fechaH = null) {
  const parsedData = []
  if (data && data.length > 0) {
    data.map((entry) => {
      let detalle = entry
      if (fechaD) { detalle = [...entry, fechaD] }
      if (fechaH) { detalle = [...entry, fechaH] }
      return parsedData.push({ ...entry, detalle: detalle })
    })
  }
  return parsedData
}

export function parsedProyecciones (data) {
  const parsedData = []
  if (data && data.length > 0) {
    data.map((proyeccion) => {
      return parsedData.push({ ...proyeccion, proyeccion: proyeccion })
    })
  }
  return parsedData
}

export function calcularEspacioDisponible (espacioAcumulado) {
  return (getState) => {
    const state = getState()
    const espacioDisponible = state.stock.espacioDisponibleElevador
    const netoPromedio = state.camionesIngreso.promedioPesoCamion
    const espacioMaximoElevador = state.stock.espacioMaximoElevador

    const netoPromedioTn = netoPromedio / 1000
    const espacioMaximo = Math.round(espacioMaximoElevador / netoPromedioTn)

    const acumulado = espacioAcumulado || 0
    const espacioDisp = espacioDisponible - acumulado

    const disponible = (espacioDisp < espacioMaximo) ? espacioDisp : espacioMaximo
    return disponible
  }
}

export function parseDataEstimacion (data, cumplimientoDefault, netoPromedio) {
  const cereales = new Set()
  const dataAgrupada = []
  const tableRows = []
  const cerealesTotal = {}

  const netoPromedioTn = netoPromedio / 1000

  if (!data || data.length === 0) {
    return { tableRows: [], grupoCereales: [] }
  }

  const espacioAcumuladoPorCereal = {}
  let espacioAcumuladoTotal = 0

  if (data.length > 0) {
    data.forEach((entry) => {
      const cereal = entry.cereal.trim()
      const fecha = entry.fecha

      if (!dataAgrupada[fecha]) {
        dataAgrupada[fecha] = {
          data: [],
          totalesDiarios: {
            cuposAsignados: 0,
            cuposADescargar: 0,
            cuposProyectados: 0,
            cumplimiento: cumplimientoDefault,
            descargaPotencial: 0,
            descargaPotencialProyectada: 0,
            embarquePotencial: 0,
            stockFinal: 0,
            stockInicial: 0
          }
        }
      }

      dataAgrupada[fecha].data.push({
        cereal: cereal,
        cuposAsignados: entry.cuposAsignados,
        cuposADescargar: entry.cuposADescargar,
        cuposProyectados: entry.cuposProyectados || 0,
        cumplimiento: entry.cumplimiento || cumplimientoDefault,
        descargaPotencial: (entry.descargaPotencial || 0) + (entry.descargaPotencialProyectada || 0),
        embarquePotencial: entry.embarquePotencial || 0,
        stockFinal: entry.stockFinal,
        stockFinalOriginal: entry.stockFinal,
        stockInicial: entry.stockInicial
      })

      const descargaTotal = (parseInt(entry.descargaPotencial) || 0) + (parseInt(entry.descargaPotencialProyectada) || 0)
      dataAgrupada[fecha].totalesDiarios.cuposAsignados += entry.cuposAsignados || 0
      dataAgrupada[fecha].totalesDiarios.cuposADescargar += entry.cuposADescargar || 0
      dataAgrupada[fecha].totalesDiarios.cuposProyectados += entry.cuposProyectados || 0
      dataAgrupada[fecha].totalesDiarios.descargaPotencial += descargaTotal
      dataAgrupada[fecha].totalesDiarios.embarquePotencial += entry.embarquePotencial || 0
      dataAgrupada[fecha].totalesDiarios.stockFinal += entry.stockFinal || 0
      dataAgrupada[fecha].totalesDiarios.stockInicial += entry.stockInicial || 0

      // se ordenan los cereales segun las toneladas de embarque potencial y cupos a descargar
      cerealesTotal[cereal] = (cerealesTotal[cereal] || 0) + entry.embarquePotencial + entry.cuposADescargar
    })

    const sortedData = Object.keys(dataAgrupada).sort()
    sortedData.forEach(dataKey => {
      const dateData = dataAgrupada[dataKey].data
      const fecha = moment(dataKey).format('DD/MM/YYYY')
      const row = {
        fechaGrupal: fecha
      }

      dateData.forEach(e => {
        const cereal = e.cereal.trim()
        cereales.add(cereal)

        const cuposADescargar = e.cuposADescargar || 0
        const cuposProyectados = e.cuposProyectados || 0
        const embarquePotencial = e.embarquePotencial || 0
        const descargaEnCupos = Math.round((e.descargaPotencial || 0) / netoPromedioTn)
        const cuposEmbarcados = Math.round(embarquePotencial / netoPromedioTn)

        espacioAcumuladoPorCereal[cereal] = (espacioAcumuladoPorCereal[cereal] || 0) + descargaEnCupos - cuposEmbarcados

        row[`${cereal}_cuposAsignados`] = e.cuposAsignados
        row[`${cereal}_cuposADescargar`] = cuposADescargar
        row[`${cereal}_cuposProyectados`] = cuposProyectados
        row[`${cereal}_cumplimiento`] = e.cumplimiento
        row[`${cereal}_stockInicial`] = e.stockInicial
        row[`${cereal}_stockFinal`] = parseInt(e.stockFinal)
        row[`${cereal}_stockFinalOriginal`] = parseInt(e.stockFinal)
        row[`${cereal}_descargaPotencial`] = parseInt(e.descargaPotencial) || 0 + parseInt(e.descargaPotencialProyectada) || 0
        row[`${cereal}_descargaPotencialProyectada`] = e.descargaPotencialProyectada || 0
        row[`${cereal}_embarquePotencial`] = e.embarquePotencial
        row[`${cereal}_entry`] = {
          cuposAsignados: e.cuposAsignados,
          cuposADescargar: e.cuposADescargar,
          cuposProyectados: e.cuposProyectados,
          cumplimiento: e.cumplimiento,
          descargaPotencial: e.descargaPotencial,
          embarquePotencial: e.embarquePotencial,
          stockFinal: parseInt(e.stockFinal),
          espacioAcumulado: espacioAcumuladoPorCereal[cereal],
          fechaGrupal: fecha
        }
      })

      const totalesDiarios = dataAgrupada[dataKey].totalesDiarios
      const descargaEnCuposTotal = Math.round((totalesDiarios.descargaPotencial || 0) / netoPromedioTn)
      const cuposEmbarcadosTotal = Math.round((totalesDiarios.embarquePotencial || 0) / netoPromedioTn)
      espacioAcumuladoTotal += descargaEnCuposTotal - cuposEmbarcadosTotal

      row['TODOS_cuposAsignados'] = totalesDiarios.cuposAsignados
      row['TODOS_cuposADescargar'] = totalesDiarios.cuposADescargar
      row['TODOS_cuposProyectados'] = totalesDiarios.cuposProyectados
      row['TODOS_descargaPotencial'] = totalesDiarios.descargaPotencial
      row['TODOS_embarquePotencial'] = totalesDiarios.embarquePotencial
      row['TODOS_stockFinal'] = totalesDiarios.stockFinal
      row['TODOS_stockFinalOriginal'] = totalesDiarios.stockFinal
      row['TODOS_stockInicial'] = totalesDiarios.stockInicial
      row['TODOS_entry'] = {
        cumplimiento: cumplimientoDefault,
        cuposAsignados: totalesDiarios.cuposAsignados,
        cuposADescargar: totalesDiarios.cuposADescargar,
        cuposProyectados: totalesDiarios.cuposProyectados,
        descargaPotencial: totalesDiarios.descargaPotencial,
        embarquePotencial: totalesDiarios.embarquePotencial,
        stockFinal: totalesDiarios.stockFinal,
        espacioAcumulado: espacioAcumuladoTotal,
        fechaGrupal: fecha
      }

      console.log('calculo espacio dispobible. ')
      const espacioDisponibleTotal = calcularEspacioDisponible(espacioAcumuladoTotal)

      row['espacioAcumuladoTotal'] = espacioAcumuladoTotal
      row['espacioDisponibleTotal'] = espacioDisponibleTotal
      tableRows.push(row)
    })
  }

  const resetRow = {
    fechaGrupal: ''
  }

  const sortedCereales = Array.from(cereales).sort((a, b) => {
    const totalA = cerealesTotal[a] || 0
    const totalB = cerealesTotal[b] || 0
    return totalB - totalA
  })

  sortedCereales.unshift('TODOS')

  sortedCereales.forEach((cereal) => {
    resetRow[`${cereal}_entry`] = {
      cumplimiento: 'CONFIG',
      cuposAsignados: 'CONFIG',
      cuposADescargar: 'CONFIG'
    }

    // resetRow[`${cereal}_cuposProyectados`] = 'CONFIG'
    // resetRow[`${cereal}_stockFinal`] = 'CONFIG'
    // resetRow[`${cereal}_descargaPotencial`] = 'CONFIG'

    resetRow[`${cereal}_embarquePotencial`] = 'CONFIG'
  })

  tableRows.push(resetRow)
  return { tableRows, grupoCereales: sortedCereales }
}

export function setSelectedCerealSimulacion2 (index, cereal) {
  return (dispatch, getState) => {
    const state = getState()

    const fieldPath = `exportadoresSimulacion[${index}].cereal`
    dispatch(change(FORM_ESTIMACION_STOCK, fieldPath, cereal))

    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const exportadorSimulacion = formValues.exportadoresSimulacion[index]
    const exportador = (exportadorSimulacion && exportadorSimulacion.exportador) ? parseEntityId(exportadorSimulacion.exportador) : 'POOL'

    const tablaSimulacion = TABLAS[`TABLA_SIMULACION_${index}`]

    dispatch({ type: 'CEREAL_ESTIMACION_STOCK', cereal })

    const data = state.stock.estimacionExportadores
    const cumplimientoDefault = state.cupos.cumplimientoCupo || 100
    const netoPromedio = state.camionesIngreso.promedioPesoCamion || 30000
    const d = data.filter((e) => parseInt(e.exportador) === parseInt(exportador))
    const { tableRows, grupoCereales } = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)

    dispatch(cargarDatosEstimacion(grupoCereales, tableRows, tablaSimulacion, cereal))
  }
}

export function setSelectedCerealSimulacion (cereal) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(resetShowDestalleCuposADescargar())
    dispatch(resetShowDestalleFechaProyeccion())

    dispatch({ type: 'CEREAL_ESTIMACION_STOCK', cereal })

    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    if (formValues && formValues.exportadoresSimulacion && formValues.exportadoresSimulacion.length > 0) {
      console.log('entra apor formValues ', formValues)
      const data = state.stock.estimacionExportadores
      const cumplimientoDefault = state.cupos.cumplimientoCupo || 100
      const netoPromedio = state.camionesIngreso.promedioPesoCamion || 30000

      formValues.exportadoresSimulacion.forEach((exportadorSimulacion, index) => {
        if (exportadorSimulacion) {
          const exportadorId = exportadorSimulacion.exportador ? parseEntityId(exportadorSimulacion.exportador) : 'POOL'

          const fieldPath = `exportadoresSimulacion[${index}].cereal`
          dispatch(change(FORM_ESTIMACION_STOCK, fieldPath, cereal))

          const dataFiltrada = data.filter((e) => parseInt(e.exportador) === parseInt(exportadorId))
          const { tableRows, grupoCereales } = parseDataEstimacion(dataFiltrada, cumplimientoDefault, netoPromedio)

          const tablaSimulacion = TABLAS[`TABLA_SIMULACION_${index}`]
          if (tablaSimulacion) {
            dispatch(cargarDatosEstimacion(grupoCereales, tableRows, tablaSimulacion, cereal))
          }
        }
      })
    }
    dispatch(actualizarEstimacionSemanal())
  }
}

export function setSelectedCereal (cereal) {
  return (dispatch) => {
    dispatch({ type: 'CEREAL_ESTIMACION_STOCK', cereal })
    dispatch({ type: 'ACTUALIZAR_CEREAL_FILTRO', cereal })
    dispatch(resetShowDestalleCuposADescargar())
    dispatch(resetShowDestalleFechaProyeccion())
    dispatch(actualizarEstimacionSemanal())
  }
}

export function updateFechaCalendario (fecha) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_FECHA_CARGA_FILTRO', fecha })
  }
}

export function updateFechaSeleccionadaProyeccion (fecha) {
  return (dispatch) => {
    dispatch({ type: 'FECHA_PROYECCION_SELECCIONADA', fecha })
  }
}

export function actualizarExportadorProyeccion (exportador, razonSocial = null) {
  return (dispatch) => {
    dispatch({ type: 'ACTUALIZAR_EXPORTADOR_PROYECCION', exportador, razonSocial })
  }
}

export const recalcularTablaConSimulacion = (
  tableRows,
  fechaSimulada,
  cereal,
  cuposSimulados,
  cumplimiento,
  state
) => {
  const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
  const netoPromedio = (formValues && formValues.netoPromedio) || state.camionesIngreso.promedioPesoCamion
  const netoPromedioTn = netoPromedio / 1000
  const cumplimientoDefault = (formValues && formValues.cumplimientoPorcentaje) || state.cupos.cumplimientoCupo || 100
  // campos
  const campoCuposADescargar = `${cereal}_cuposADescargar`
  const campoCuposProyectados = `${cereal}_cuposProyectados`
  const campoDescarga = `${cereal}_descargaPotencial`
  const campoEmbarque = `${cereal}_embarquePotencial`
  const campoStockInicial = `${cereal}_stockInicial`
  const campoStock = `${cereal}_stockFinal`
  const campoStockOriginal = `${cereal}_stockFinalOriginal`
  const campoCumplimiento = `${cereal}_cumplimiento`
  const campoEntry = `${cereal}_entry`

  const partesFecha = fechaSimulada.split('/')
  const fechaComparacion = new Date(parseInt(partesFecha[2]), parseInt(partesFecha[1]) - 1, parseInt(partesFecha[0]))

  let stockFinalDiaAnterior = 0
  let espacioAcumuladoDiaAnterior = 0
  let stockFinalDiaAnteriorTODOS = 0
  let espacioAcumuladoDiaAnteriorTODOS = 0

  if (tableRows && tableRows.length > 0) {
    const primerDia = tableRows[0]
    stockFinalDiaAnterior = primerDia[campoStockInicial] || 0

    const descargaEnCupos = Math.round((primerDia[campoDescarga] || 0) / netoPromedioTn)
    const embarquePotencialTnDia0 = primerDia[campoEmbarque] || 0
    const cuposEmbarcadosDia0 = Math.round(embarquePotencialTnDia0 / netoPromedioTn)
    const cambioNetoCuposDia0 = descargaEnCupos - cuposEmbarcadosDia0
    espacioAcumuladoDiaAnterior = (primerDia[campoEntry].espacioAcumulado || 0) - cambioNetoCuposDia0

    const espacioAcumuladoDia0 = primerDia.espacioAcumuladoTotal || primerDia.TODOS_entry.espacioAcumulado || 0
    stockFinalDiaAnteriorTODOS = primerDia.TODOS_stockInicial || 0

    const descargaPotencialDia0TODOS = primerDia.TODOS_descargaPotencial || 0
    const descargaEnCuposTODOS = Math.round(descargaPotencialDia0TODOS / netoPromedioTn)
    const embarquePotencialTnDia0TODOS = primerDia.TODOS_embarquePotencial || 0
    const cuposEmbarcadosDia0TODOS = Math.round(embarquePotencialTnDia0TODOS / netoPromedioTn)

    const cambioNetoCuposDia0TODOS = descargaEnCuposTODOS - cuposEmbarcadosDia0TODOS
    espacioAcumuladoDiaAnteriorTODOS = espacioAcumuladoDia0 - cambioNetoCuposDia0TODOS
  }
  return tableRows.map((r) => {
    const filaActualizada = { ...r }
    const stockOriginal = stockFinalDiaAnterior

    const oldDescargaPotencialCereal = filaActualizada[campoDescarga] || 0
    const oldCuposProyectadosCereal = filaActualizada[campoCuposProyectados] || 0
    const oldCuposADescargarCereal = filaActualizada[campoCuposADescargar] || 0

    const oldTODOScuposADescargar = filaActualizada.TODOS_cuposADescargar || 0
    const oldTODOSdescargaPotencial = filaActualizada.TODOS_descargaPotencial || 0
    const oldTODOScuposProyectados = filaActualizada.TODOS_cuposProyectados || 0

    let cumplimientoCupo = filaActualizada[campoCumplimiento] ? filaActualizada[campoCumplimiento] : cumplimientoDefault
    const cuposADescargarBase = filaActualizada[campoCuposADescargar]
    let cuposProyectados = filaActualizada[campoCuposProyectados]

    const rPartesFecha = filaActualizada.fechaGrupal.split('/')
    const rFechaObj = new Date(parseInt(rPartesFecha[2]), parseInt(rPartesFecha[1]) - 1, parseInt(rPartesFecha[0]))

    if (filaActualizada.fechaGrupal === fechaSimulada) {
      if (cumplimiento !== null) {
        cumplimientoCupo = parseInt(cumplimiento)
      }

      cuposProyectados = (cuposSimulados !== null && cuposSimulados !== undefined)
        ? parseInt(cuposSimulados)
        : filaActualizada[campoCuposProyectados]

      const embarquePotencial = filaActualizada[campoEmbarque] || 0
      const descargaPotencialDia = (cuposADescargarBase + cuposProyectados) * netoPromedio * cumplimientoCupo / 100000
      const stockFinalSimulacion = stockOriginal + descargaPotencialDia - embarquePotencial

      const cuposEmbarcados = Math.round(embarquePotencial / netoPromedioTn)
      const descargaEnCupos = Math.round(descargaPotencialDia / netoPromedioTn)
      const cambioEspacioAcumulado = descargaEnCupos - cuposEmbarcados
      const espacioAcumuladoNuevo = espacioAcumuladoDiaAnterior + cambioEspacioAcumulado

      filaActualizada[campoCuposProyectados] = cuposProyectados
      filaActualizada[campoCuposADescargar] = cuposADescargarBase
      filaActualizada[campoCumplimiento] = cumplimientoCupo
      filaActualizada[campoDescarga] = descargaPotencialDia
      filaActualizada[campoStock] = stockFinalSimulacion
      filaActualizada[campoEntry] = {
        ...(filaActualizada[campoEntry] || {}),
        cuposAsignados: cuposADescargarBase,
        cuposADescargar: cuposADescargarBase,
        cuposProyectados: cuposProyectados,
        cumplimiento: cumplimientoCupo,
        fechaGrupal: filaActualizada.fechaGrupal,
        espacioAcumulado: espacioAcumuladoNuevo,
        stockFinal: stockFinalSimulacion,
        embarquePotencial: filaActualizada[campoEmbarque]
      }

      espacioAcumuladoDiaAnterior = espacioAcumuladoNuevo
    }

    // propagacion
    if (rFechaObj.getTime() > fechaComparacion.getTime()) {
      const descargaPotencialDia = (cuposADescargarBase + cuposProyectados) * netoPromedio * cumplimientoCupo / 100000

      filaActualizada[campoCumplimiento] = cumplimientoCupo
      filaActualizada[campoDescarga] = descargaPotencialDia
      const embarquePotencial = filaActualizada[campoEmbarque] || 0
      const cuposEmbarcados = Math.round(embarquePotencial / netoPromedioTn)

      const stockTotal = stockOriginal + descargaPotencialDia - embarquePotencial
      const descargaEnCupos = Math.round(filaActualizada[campoDescarga] / netoPromedioTn)

      const cambioEspacioAcumulado = descargaEnCupos - cuposEmbarcados
      const espacioAcumuladoNuevo = espacioAcumuladoDiaAnterior + cambioEspacioAcumulado

      filaActualizada[campoEntry] = { ...filaActualizada[campoEntry], espacioAcumulado: espacioAcumuladoNuevo, stockFinal: stockTotal }
      filaActualizada[campoStock] = stockTotal
    }

    filaActualizada.TODOS_cuposADescargar = (oldTODOScuposADescargar - oldCuposADescargarCereal) + (filaActualizada[campoCuposADescargar] || 0)
    filaActualizada.TODOS_descargaPotencial = (oldTODOSdescargaPotencial - oldDescargaPotencialCereal) + (filaActualizada[campoDescarga] || 0)
    filaActualizada.TODOS_cuposProyectados = (oldTODOScuposProyectados - oldCuposProyectadosCereal) + (filaActualizada[campoCuposProyectados] || 0)

    const descargaPotencialTotal = filaActualizada.TODOS_descargaPotencial || 0
    const embarquePotencialTotal = filaActualizada.TODOS_embarquePotencial || 0

    const stockFinalTotal = stockFinalDiaAnteriorTODOS + descargaPotencialTotal - embarquePotencialTotal

    const cuposEmbarcadosTotal = Math.round(embarquePotencialTotal / netoPromedioTn)
    const descargaEnCuposTotal = Math.round(descargaPotencialTotal / netoPromedioTn)
    const cambioEspacioAcumuladoTotal = descargaEnCuposTotal - cuposEmbarcadosTotal
    const espacioAcumuladoTotal = espacioAcumuladoDiaAnteriorTODOS + cambioEspacioAcumuladoTotal

    filaActualizada.TODOS_stockFinal = stockFinalTotal
    filaActualizada.TODOS_entry = {
      ...(filaActualizada.TODOS_entry || {}),
      cuposProyectados: filaActualizada.TODOS_cuposProyectados,
      cuposADescargar: filaActualizada.TODOS_cuposADescargar,
      descargaPotencial: filaActualizada.TODOS_descargaPotencial,
      espacioAcumulado: espacioAcumuladoTotal,
      stockFinal: stockFinalTotal
    }

    filaActualizada.espacioAcumuladoTotal = espacioAcumuladoTotal

    stockFinalDiaAnterior = filaActualizada[campoStock] || filaActualizada[campoStockOriginal] || 0
    espacioAcumuladoDiaAnterior = filaActualizada[campoEntry].espacioAcumulado || 0
    stockFinalDiaAnteriorTODOS = stockFinalTotal
    espacioAcumuladoDiaAnteriorTODOS = espacioAcumuladoTotal

    return filaActualizada
  })
}

export function handleToggleUnidad (campo) {
  return (dispatch, getState) => {
    dispatch({ type: 'TOGGLE_UNIDAD_VISUAL', campo })

    const state = getState()
    const grupoCereales = state.stock.cerealesEstimacion
    const tableRows = state.stock.tableRowsEstimacion

    return dispatch(cargarDatosEstimacion(grupoCereales, tableRows))
  }
}

export function cargarDatosEstimacion (grupoCereales = null, tableRows = null, tabla = null, cerealSimulacion = null) {
  return (dispatch, getState) => {
    const state = getState()

    const unidadVisual = state.stock.unidadVisual || 'TN'
    const unidadVisualDescarga = state.stock.unidadVisualDescarga || 'CAMIONES'

    const isSimulacion = state.stock.isSimulacion
    const isSimulacionExportador = !!tabla && tabla !== TABLAS.TABLA_ESTIMACION_SEMANAL && tabla !== TABLAS.TABLA_SIMULACION_POOL
    const simulacionesPersistidas = state.stock.simulacionesPersistidas
    const netoPromedio = state.camionesIngreso.promedioPesoCamion
    const netoPromedioTn = netoPromedio / 1000
    const espacioDisponible = state.stock.espacioDisponibleElevador
    const receiveDatos = state.stock.datosProyeccionActualizados

    const cereales = grupoCereales || state.stock.cerealesEstimacion
    const data = tableRows || state.stock.tableRowsEstimacion || []
    let tableRowsRecalculados = [...data]

    let formValues = null
    const exportadorProyeccion = state.stock.exportadorProyeccionNombre
    let exportadorSimulacion = exportadorProyeccion || 'POOL'

    const tablaPool = isSimulacion ? TABLAS.TABLA_SIMULACION_POOL : TABLAS.TABLA_ESTIMACION_SEMANAL

    const idTabla = tabla || tablaPool
    let indexSimulacion = null

    if (isSimulacionExportador) {
      const parts = idTabla.split('_')
      indexSimulacion = parseInt(parts[parts.length - 1])
    }

    if (isSimulacionExportador) {
      const formState = state.form[FORM_ESTIMACION_STOCK]
      if (formState && formState.values) {
        formValues = formState.values
      }
    }

    const cerealEstimacion = state.stock.cerealEstimacionStock
    let cereal = cerealEstimacion

    if (cerealSimulacion) {
      cereal = cerealSimulacion
    }

    // let simulacionPorExportador = false
    const exportadores = formValues && formValues.exportadoresSimulacion

    if (isSimulacionExportador && indexSimulacion !== null && exportadores && exportadores.length > indexSimulacion && indexSimulacion >= 0) {
      // simulacionPorExportador = true
      exportadorSimulacion = exportadores[indexSimulacion].exportador
      cereal = exportadores[indexSimulacion].cereal || cereal
    } else if (formValues && formValues.simulacionActiva !== undefined) {
      const simulacionActiva = formValues.simulacionActiva
      if (exportadores && exportadores.length > simulacionActiva && simulacionActiva >= 0) {
        // simulacionPorExportador = true
        exportadorSimulacion = exportadores[simulacionActiva].exportador
        cereal = exportadores[simulacionActiva].cereal
      }
    }

    if (!cereal) {
      cereal = cereales[0]
    }

    dispatch({ type: 'ACTUALIZAR_CEREAL_FILTRO', cereal })

    const simulacionesAplicables = simulacionesPersistidas.filter(sim =>
      sim.exportador === exportadorSimulacion
    )

    if (simulacionesAplicables.length > 0) {
      simulacionesAplicables.forEach(simulacion => {
        tableRowsRecalculados = recalcularTablaConSimulacion(
          tableRowsRecalculados,
          simulacion.fecha,
          simulacion.cereal,
          simulacion.cuposSimulados,
          simulacion.cumplimiento,
          getState()
        )
      })
    }

    if (!cerealEstimacion) {
      dispatch({ type: 'CEREAL_ESTIMACION_STOCK', cereal })
    }

    const stockInicial = (data && data.length > 0) ? data[0][`${cereal}_stockInicial`] : null
    const ultimoStock = stockInicial && stockInicial > 0 ? stockInicial.toLocaleString() : `${stockInicial}`

    const customToolbar = () => (
      <>
        {data && data.length > 0 &&
          <Col md={12}>
            { ultimoStock && <span style={{ fontSize: '1rem' }}>
              Último stock consolidado (01hs.): <span style={{ fontWeight: 'bold' }}> {ultimoStock} tn. </span>
            </span> }
          </Col>
        }

        {(!data || data.length === 0) && receiveDatos &&
          <Col md={12} style={{ padding: '18px', display: 'flex', alignItems: 'center' }}>
            <ErrorIcon style={{ color: COLORES.grey.mediumDark }} />
            <span style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem', color: COLORES.grey.dark }}>
                  No se obtuvieron datos para la proyección de stock
            </span>
          </Col>
        }
      </>
    )
    const customToolbarLeft = () => (
      <>
        {data && data.length > 0 && !isSimulacionExportador
          ? <OpcionesCerealEstimacion
            isSimulacionExportador={isSimulacionExportador}
            indexSimulacion={indexSimulacion}
          />
          : <></>
        }
      </>
    )

    const toggleUnidadHandler = (campo) => {
      dispatch(handleToggleUnidad(campo))
    }

    const actualizarFecha = (fecha) => {
      dispatch(resetShowDestalleCuposADescargar())
      dispatch(resetShowDestalleFechaProyeccion())
      dispatch(updateFechaSeleccionadaProyeccion(fecha))
      dispatch(showDataFechaProyeccion(fecha, tableRowsRecalculados, cereal))
      dispatch(updateFechaCalendario(fecha))
      if (!isSimulacion) {
        dispatch(cargarDatosEstimacion(null, tableRows, tabla, cerealSimulacion))
      }
    }

    const fechaSeleccionada = state.stock.fechaProyeccionSeleccionada
    const showEspacioDisponible = !isSimulacionExportador && !!espacioDisponible

    const columnas = COLUMNAS.columnasEstimacionSemanal(
      cereal,
      netoPromedioTn,
      isSimulacion,
      isSimulacionExportador,
      showEspacioDisponible,
      unidadVisual,
      unidadVisualDescarga,
      actualizarFecha,
      toggleUnidadHandler
    )

    const setRowProps = (rowData, dataIndex) => {
      const fechaFila = tableRowsRecalculados[dataIndex].fechaGrupal
      if (fechaFila === fechaSeleccionada && !isSimulacion) {
        return {
          style: {
            backgroundColor: '#b1b1b1',
            color: '#303030',
            fontWeight: 'bold'
          }
        }
      }
      return {}
    }

    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: columnas,
        data: tableRowsRecalculados,
        title: ' ',
        isLoading: false,
        fixed2Decimales: false,
        extraOptions: {
          customToolbar: customToolbar,
          customToolbarLeft: customToolbarLeft,
          setRowProps: setRowProps,
          print: false,
          pagination: false,
          tableBodyMaxHeight: '850px',
          viewColumns: false,
          search: false,
          hideTitle: true,
          filter: false,
          download: false
        }
      },
      id: idTabla
    })
  }
}

export function resetCumplimiento (cereal) {
  return (dispatch, getState) => {
    const state = getState()
    const tableRows = state.stock.tableRowsEstimacion
    const cumplimiento = state.cupos.cumplimiento || 100

    tableRows.map((r) => {
      const campoCumplimiento = `${cereal}_cumplimiento`
      r[campoCumplimiento] = cumplimiento
      return campoCumplimiento
    })
    // ENVIO EXPORTADOR?
    dispatch(actualizarEstimacionSemanal())
  }
}

export function actualizarSimulacionActiva (simulacion) {
  return (dispatch) => {
    dispatch({ type: 'SIMULACION_ACTIVA', simulacion })
  }
}

export function cleanSimulacionesPersistidas (exportador) {
  return {
    type: 'CLEAN_SIMULACIONES_PERSISTIDAS',
    exportador
  }
}

export function editarProyeccionExportador () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const proyectados = state.stock.cuposProyectadosShow
    const fecha = state.stock.fechaProyeccionShow
    const cereal = state.stock.cerealEstimacionStock
    const cumplimiento = formValues.cumplimientoExportador
    const exportador = formValues.exportadorProyeccion

    const dataToSave = {
      fecha: fecha,
      cereal: cereal,
      exportador: parseEntityId(exportador),
      cantidadAsignada: proyectados,
      cumplimiento: cumplimiento
    }

    return proyeccionStock.saveProyeccionExportador(dataToSave)
      .then(async (result) => {
        if (!result.error) {
          dispatch({
            type: 'UPDATE_MUITABLE',
            newState: {
              isLoading: true
            },
            id: TABLAS.TABLA_ESTIMACION_SEMANAL
          })
          await dispatch(obtenerEstimacionSemanalExportadores())
          // dispatch(actualizarEstimacionSemanal())
        }
      })
      .catch((error) => {
        toast.error('Error al intentar guardar simulaciones')
        console.log(error)
      })
  }
}

export function saveSimulacionExportador (index, exportador) {
  return async (dispatch, getState) => {
    const state = getState()
    // const idTablaSimulacion = `TABLA_SIMULACION_${index}`
    // const tablaSimulacion = state.muitable.muiTables[idTablaSimulacion]
    const simulacionesPersistidas = state.stock.simulacionesPersistidas

    const simulacionesParaGuardar = simulacionesPersistidas.filter(sim =>
      sim.exportador === exportador
    )

    const savePromises = simulacionesParaGuardar.map((simulacion) => {
      const dataToSave = {
        fecha: simulacion.fecha,
        cereal: simulacion.cereal,
        exportador: parseEntityId(simulacion.exportador),
        cantidadAsignada: simulacion.cuposSimulados,
        cumplimiento: simulacion.cumplimiento
      }

      return proyeccionStock.saveProyeccionExportador(dataToSave)
        .catch((error) => {
          toast.error('Error al intentar guardar simulaciones')
          console.log('Error guardando simulacion ', simulacion, ' : ', error)
          return { success: false, error: error, simulacion: simulacion }
        })
    })

    try {
      const results = await Promise.all(savePromises)
      console.log('Simulaciones guardadas: ', results)
      const allSuccess = results.every(res => !res.error)

      if (allSuccess) {
        toast.success('Los datos de la simulacion se guardaron correctamente')
        dispatch(cleanSimulacionesPersistidas(exportador))
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            isLoading: true
          },
          id: TABLAS[`TABLA_SIMULACION_${index}`]
        })
        await dispatch(obtenerEstimacionSemanalExportadores(exportador, index))
        // dispatch(obtenerSimulacionExportador(parseEntityId(exportador), index))
      }
    } catch (error) {
      console.log('Error al intentar guardar simulaciones: ', error)
      toast.error('Error al intentar guardar simulaciones')
    }
  }
}

export function actualizarSimulacionesActivas () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    if (formValues && formValues.exportadoresSimulacion) {
      const exportadoresSimulacion = formValues.exportadoresSimulacion
      exportadoresSimulacion && exportadoresSimulacion.map(async (exportador, index) => {
        dispatch(cleanSimulacionesPersistidas(exportador))
        console.log('exportador e index ', exportador, index)
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            isLoading: true
          },
          id: TABLAS[`TABLA_SIMULACION_${index}`]
        })

        await dispatch(obtenerEstimacionSemanalExportadores(exportador, index))
      })
    }
  }
}

export function saveSimulacionExportadores () {
  return async (dispatch, getState) => {
    const state = getState()
    // const idTablaSimulacion = `TABLA_SIMULACION_${index}`
    // const tablaSimulacion = state.muitable.muiTables[idTablaSimulacion]
    // const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const simulacionesPersistidas = state.stock.simulacionesPersistidas

    const simulacionesParaGuardar = simulacionesPersistidas.filter(sim =>
      sim.exportador !== 'POOL'
    )

    const savePromises = simulacionesParaGuardar.map((simulacion) => {
      const dataToSave = {
        fecha: simulacion.fecha,
        cereal: simulacion.cereal,
        exportador: parseEntityId(simulacion.exportador),
        cantidadAsignada: simulacion.cuposSimulados,
        cumplimiento: simulacion.cumplimiento
      }

      return proyeccionStock.saveProyeccionExportador(dataToSave)
        .catch((error) => {
          toast.error('Error al intentar guardar simulaciones')
          console.log('Error guardando simulacion ', simulacion, ' : ', error)
          return { success: false, error: error, simulacion: simulacion }
        })
    })

    try {
      const results = await Promise.all(savePromises)
      console.log('Simulaciones guardadas: ', results)
      const allSuccess = results.every(res => !res.error)

      if (allSuccess) {
        toast.success('Los datos de la simulacion se guardaron correctamente')
        // por cada simulacion activa
        await dispatch(obtenerEstimacionSemanal())
        await dispatch(actualizarSimulacionesActivas())
        dispatch(obtenerProyeccionExportador())
      }
    } catch (error) {
      console.log('Error al intentar guardar simulaciones: ', error)
      toast.error('Error al intentar guardar simulaciones')
    }
  }
}

export function actualizarExportadoresActivos (data) {
  return (dispatch) => {
    const exportadores = []
    data && data.map((d) => {
      const exportador = `${d.nombreExportador} - ${d.exportador}`
      if (!exportadores.includes(exportador)) {
        return exportadores.push(exportador)
      }
      return exportadores
    })
    dispatch({ type: 'ACTUALIZAR_EXPORTADORES_ACTIVOS', exportadores })
  }
}

export const saveSimulacionPreliminar = (simulacionData) => ({
  type: 'SAVE_SIMULACION_PRELIMINAR',
  payload: simulacionData
})

export function updateEspacioDisponibleElevador (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_ESPACIO_ELEVADOR', newValue })
    dispatch(updateParametroInteger('ESPADISP', newValue))
  }
}

export function updateParametroInteger (nombre, value) {
  return () => {
    return ParametroInteger.updateByNombre(nombre, value)
  }
}

export function obtenerEspacioDisponibleElevador () {
  return (dispatch) => {
    ParametroInteger.getByNombre('ESPADISP')
      .then((netoPromedio) => {
        const newValue = netoPromedio['valor']
        dispatch({ type: 'UPDATE_ESPACIO_ELEVADOR', newValue })
      })
  }
}

export function obtenerEspacioMaximoElevador () {
  return (dispatch) => {
    ParametroInteger.getByNombre('ESPTOTAL')
      .then((netoPromedio) => {
        const newValue = netoPromedio['valor']
        dispatch({ type: 'UPDATE_ESPACIO_MAXIMO_ELEVADOR', newValue })
      })
  }
}

export function updateIsSimulacion (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_IS_SIMULACION', newValue })
  }
}

export function resetShowDestalleCuposADescargar () {
  return (dispatch) => {
    dispatch({ type: 'RESET_DETALLE_CUPOS' })
  }
}

export function showDetalleCuposADescargar (cupos, proyectados, fecha, cumplimiento, descargaPotencial) {
  return (dispatch) => {
    dispatch({ type: 'SHOW_DETALLE_CUPOS', cupos, proyectados, fecha, cumplimiento, descargaPotencial })
  }
}

export function showDataFechaProyeccion (fecha, estimacion, cereal) {
  return (dispatch) => {
    const cerealKey = cereal ? `${cereal.trim()}_entry` : null
    const data = estimacion && estimacion.filter((e) => e.fechaGrupal === fecha)

    let dataCereal
    let detalleFecha = {}
    if (data && data.length > 0 && cerealKey) {
      dataCereal = data[0][cerealKey]

      detalleFecha = {
        ...dataCereal,
        espacioAcumuladoTotal: data.espacioAcumuladoTotal
      }
    }

    dispatch({ type: 'SHOW_DETALLE_FECHA', detalleFecha })
  }
}

export function resetShowDestalleFechaProyeccion () {
  return (dispatch) => {
    dispatch({ type: 'RESET_DETALLE_FECHA' })
  }
}

export function simularCupos (fecha, cereal, cupos, cumplimiento = null) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const cumplimientoDefault = state.cupos.cumplimientoCupo
    const isSimulacion = state.stock.isSimulacion
    const exportadorProyeccion = state.stock.exportadorProyeccionNombre

    let simulacionIndex = null
    let exportadorSimulacion = exportadorProyeccion || 'POOL'

    let simulacionPorExportador = false

    if (formValues && formValues.exportadoresSimulacion && formValues.simulacionActiva !== undefined) {
      simulacionIndex = formValues.simulacionActiva
      const simulaciones = formValues.exportadoresSimulacion

      if (simulaciones.length > simulacionIndex && simulacionIndex !== null && simulacionIndex >= 0) {
        simulacionPorExportador = true
        exportadorSimulacion = simulaciones[simulacionIndex].exportador
      }
    }

    // persistir simulacion
    const simulacionAPersistir = {
      id: `${cereal}_${fecha}_${exportadorSimulacion}`,
      fecha: fecha,
      cereal: cereal,
      exportador: exportadorSimulacion,
      cuitExportador: exportadorSimulacion !== 'POOL' ? parseEntityId(exportadorSimulacion) : null,
      cuposSimulados: parseInt(cupos) || 0,
      cumplimiento: cumplimiento ? parseInt(cumplimiento) : cumplimientoDefault
    }

    dispatch(saveSimulacionPreliminar(simulacionAPersistir))
    let idTablaProyeccion

    // tabla de simulacion
    if (isSimulacion) {
      if (simulacionPorExportador) {
        idTablaProyeccion = `TABLA_SIMULACION_${simulacionIndex}`
      } else {
        idTablaProyeccion = 'TABLA_SIMULACION_POOL'
      }
    } else {
      idTablaProyeccion = 'TABLA_ESTIMACION_SEMANAL'
    }

    const tablaProyeccion = state.muitable.muiTables[idTablaProyeccion]
    const tableRows = tablaProyeccion ? tablaProyeccion.data : []

    dispatch(cargarDatosEstimacion(null, tableRows, idTablaProyeccion, cereal))
  }
}

export function restoreCumplimiento (cereal, cumplimiento = null) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const simulacionesPersistidas = state.stock.simulacionesPersistidas
    const isSimulacion = state.stock.isSimulacion

    const cumplimientoDefault = state.cupos.cumplimientoCupo
    const newCumplimiento = parseInt(cumplimiento) || cumplimientoDefault

    let simulacionIndex = null

    let exportadorSimulacion = 'POOL'
    let simulacionPorExportador = false

    if (formValues && formValues.exportadoresSimulacion && formValues.simulacionActiva !== undefined) {
      simulacionIndex = formValues.simulacionActiva
      const simulaciones = formValues.exportadoresSimulacion

      if (simulaciones.length > simulacionIndex && simulacionIndex !== null && simulacionIndex >= 0) {
        simulacionPorExportador = true
        exportadorSimulacion = simulaciones[simulacionIndex].exportador
      }
    }

    let tableRows
    let idTablaSimulacion

    // tabla de simulacion
    if (isSimulacion) {
      if (simulacionPorExportador) {
        idTablaSimulacion = `TABLA_SIMULACION_${simulacionIndex}`
      } else {
        idTablaSimulacion = 'TABLA_SIMULACION_POOL'
      }
      const tablaSimulacion = state.muitable.muiTables[idTablaSimulacion]
      tableRows = tablaSimulacion ? tablaSimulacion.data : []
    } else {
      idTablaSimulacion = 'TABLA_ESTIMACION_SEMANAL'
      tableRows = state.stock.tableRowsEstimacion
    }

    const simulacionesToPersist = []

    tableRows.forEach(row => {
      if (row[`${cereal}_entry`].cumplimiento !== 'CONFIG') {
        const fecha = row.fechaGrupal

        const existeSimulacion = simulacionesPersistidas.find(s =>
          s.fecha === fecha &&
          s.cereal === cereal &&
          s.exportador === exportadorSimulacion
        )

        const cuposSimulados = existeSimulacion ? existeSimulacion.cuposSimulados : null
        const currentCumplimiento = existeSimulacion ? existeSimulacion.cumplimiento : 100

        if (currentCumplimiento !== newCumplimiento) {
          const simulacionAPersistir = {
            id: `${cereal}_${fecha}_${exportadorSimulacion}`,
            fecha: fecha,
            cereal: cereal,
            exportador: exportadorSimulacion,
            cuitExportador: exportadorSimulacion !== 'POOL' ? parseEntityId(exportadorSimulacion) : null,
            cuposSimulados: cuposSimulados,
            cumplimiento: newCumplimiento
          }

          simulacionesToPersist.push(simulacionAPersistir)
        }
      }
    })

    simulacionesToPersist.forEach(simulacion => {
      dispatch(saveSimulacionPreliminar(simulacion))
    })

    dispatch(cargarDatosEstimacion(null, tableRows, idTablaSimulacion, cereal))
  }
}

export function resetSimulacionPool () {
  return (dispatch) => {
    dispatch(cleanSimulacionesPersistidas('POOL'))
    dispatch(obtenerEstimacionSemanal())
  }
}

export function actualizarEstimacionSemanal () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const exportadorProyeccion = state.stock.exportadorProyeccion
    const isSimulacion = state.stock.isSimulacion

    let index = null
    let exportador = null

    // se verifica si hay simulacion activa de un exportador
    if (formValues && formValues.simulacionActiva !== undefined) {
      index = formValues.simulacionActiva
      const exportadorSimulacion = formValues.exportadoresSimulacion[index]
      exportador = parseEntityId(exportadorSimulacion.exportador)
    } else if (exportadorProyeccion) {
      exportador = exportadorProyeccion
    }

    const tablaPool = isSimulacion ? TABLAS.TABLA_SIMULACION_POOL : TABLAS.TABLA_ESTIMACION_SEMANAL
    const tabla = TABLAS[`TABLA_SIMULACION_${index}`] || tablaPool

    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true,
        data: []
      },
      id: tabla
    })

    if (exportador) {
      const data = state.stock.estimacionExportadores
      const cumplimientoDefault = (formValues && formValues.cumplimientoPorcentaje) || state.cupos.cumplimientoCupo
      const netoPromedio = (formValues && parseInt(formValues.netoPromedio)) || state.camionesIngreso.promedioPesoCamion
      const d = data.filter((e) => parseInt(e.exportador) === parseInt(exportador))
      const { tableRows, grupoCereales } = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)
      return dispatch(cargarDatosEstimacion(grupoCereales, tableRows, tabla))
    }

    dispatch(cargarDatosEstimacion())
  }
}

export function deleteProyeccionExportador (fecha, cereal, exportador) {
  return (dispatch) => {
    return proyeccionStock.deleteProyeccion(fecha, cereal, exportador)
      .then((result) => {
        if (!result.error) {
          toast.success('La proyeccion fue eliminada correctamente')
          dispatch(obtenerEstimacionSemanal())
          // actualizar proyeccion exportadores
          dispatch(actualizarSimulacionesActivas())
          dispatch(obtenerProyeccionExportador())
        } else {
          toast.error('Error al intentar eliminar la proyeccion')
          console.log(result)
        }
      })
      .catch((error) => {
        toast.error('Error al intentar eliminar la proyeccion')
        console.log(error)
      })
  }
}

export function obtenerProyeccionExportador () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_PROYECCION_EXPORTADOR
    })

    return proyeccionStock.getProyeccionExportador()
      .then((d) => {
        const data = parsedProyecciones(d)
        dispatch({ type: 'CUPOS_PROYECTADOS', data })
        const proyectados = data.filter(d => d.cantidadAsignada > 0)
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_PROYECCION,
            data: proyectados,
            title: 'Cupos proyectados',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar: null,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '450px',
              download: false
            }
          },
          id: TABLAS.TABLA_PROYECCION_EXPORTADOR
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerEstimacionSemanal () {
  return (dispatch, getState) => {
    dispatch({ type: 'RESET_ESTIMACION_SEMANAL' })
    const state = getState()
    const formValues = getFormValues(FORM_ESTIMACION_STOCK)(state)
    const cumplimientoDefault = (formValues && formValues.cumplimientoPorcentaje) || state.cupos.cumplimientoCupo
    const netoPromedio = state.camionesIngreso.promedioPesoCamion || 30000
    const isSimulacion = state.stock.isSimulacion

    const idTabla = isSimulacion ? TABLAS.TABLA_SIMULACION_POOL : TABLAS.TABLA_ESTIMACION_SEMANAL

    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: idTabla
    })

    stockListado.getEstimacionSemanal()
      .then((d) => {
        const { tableRows, grupoCereales } = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)
        dispatch({ type: 'SAVE_ESTIMACION_SEMANAL', tableRows, grupoCereales })
        dispatch(cargarDatosEstimacion(grupoCereales, tableRows))
        const exportadoresSimulacion = formValues ? formValues.exportadoresSimulacion : []
        if (exportadoresSimulacion.length > 0) {
          exportadoresSimulacion.map(e => {
            return dispatch({
              type: 'UPDATE_MUITABLE',
              newState: {
                isLoading: true
              },
              id: TABLAS[`TABLA_SIMULACION_${e.index}`]
            })
          })
        }
        dispatch(obtenerEstimacionSemanalExportadores())
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerEstimacionSemanalExportadores (exportador = null, index = null) {
  return (dispatch) => {
    stockListado.getEstimacionSemanalExportadores()
      .then((data) => {
        dispatch({ type: 'SAVE_ESTIMACION_SEMANAL_EXPORTADORES', data })
        dispatch(actualizarEstimacionSemanal())
        const dataActivos = data.filter(d => d.cuposAsignados > 0 || d.embarquePotencial > 0 || d.cuposProyectados > 0)
        dispatch(actualizarExportadoresActivos(dataActivos))
        if (exportador) { dispatch(obtenerSimulacionExportador(parseEntityId(exportador), index)) }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerSimulacionExportador (exportador, index) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS[`TABLA_SIMULACION_${index}`]
    })

    const data = state.stock.estimacionExportadores
    const cumplimientoDefault = state.cupos.cumplimientoCupo
    const netoPromedio = state.camionesIngreso.promedioPesoCamion
    const d = data.filter((e) => parseInt(e.exportador) === parseInt(exportador))
    const { tableRows, grupoCereales } = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)
    const tablaSimulacion = TABLAS[`TABLA_SIMULACION_${index}`]
    return dispatch(cargarDatosEstimacion(grupoCereales, tableRows, tablaSimulacion))
  }
}

export function obtenerEstimacionSemanalExportador (exportador) {
  return (dispatch, getState) => {
    const state = getState()
    const data = state.stock.estimacionExportadores
    const cumplimientoDefault = state.cupos.cumplimientoCupo
    const netoPromedio = state.camionesIngreso.promedioPesoCamion
    const isSimulacion = state.stock.isSimulacion

    const idTabla = isSimulacion ? TABLAS.TABLA_SIMULACION_POOL : TABLAS.TABLA_ESTIMACION_SEMANAL

    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: idTabla
    })

    const d = data.filter((e) => parseInt(e.exportador) === parseInt(exportador))
    const { tableRows, grupoCereales } = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)
    return dispatch(cargarDatosEstimacion(grupoCereales, tableRows))
  }
}

// export function obtenerEstimacionPorCereal () {
//   return (dispatch, getState) => {
//     const state = getState()
//     const cumplimientoDefault = state.cupos.cumplimientoCupo
//     const netoPromedio = state.camionesIngreso.promedioPesoCamion
//     const isSimulacion = state.stock.isSimulacion

//     const idTabla = isSimulacion ? TABLAS.TABLA_SIMULACION_POOL : TABLAS.TABLA_ESTIMACION_SEMANAL

//     dispatch({
//       type: 'UPDATE_MUITABLE',
//       newState: {
//         isLoading: true
//       },
//       id: idTabla
//     })

//     const titulo = 'Estimacion semanal por cereal y exportador'
//     stockListado.getEstimacionSemanalCereal()
//       .then((d) => {
//         const data = parseDataEstimacion(d, cumplimientoDefault, netoPromedio)
//         const dataFinal = []
//         Object.keys(data).forEach(cereal => {
//           dataFinal.push({ ...null, cereal: cereal })
//           data[cereal].data.forEach(d => {
//             dataFinal.push({ ...d })
//           })
//         })

//         const customToolbar = pdfCustomToolbarGenerator(
//           titulo,
//           dataFinal,
//           COLUMNAS.ESTIMACION_POR_CEREAL_TO_PRINT,
//           'landscape'
//         )

//         dispatch({
//           type: 'UPDATE_MUITABLE',
//           newState: {
//             columns: COLUMNAS.COL_ESTIMACION_POR_CEREAL,
//             data: dataFinal,
//             title: titulo,
//             isLoading: false,
//             fixed2Decimales: false,
//             extraOptions: {
//               customToolbar,
//               print: false,
//               pagination: false,
//               tableBodyMaxHeight: '599px'
//             }
//           },
//           id: idTabla
//         })
//       })
//       .catch((error) => {
//         console.log(error)
//         toast.error('Error al intentar obtener los datos')
//       })
//   }
// }

export function obtenerCuposVigentes () {
  return (dispatch) => {
    return getCuposVigentes()
      .then((data) => {
        dispatch(saveCuposVigentes(data))
      })
  }
}

export function obtenerTransferenciasExportadores (exportador = null) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_TRANSFERENCIAS_EXPORTADOR
    })

    const cuitExportador = exportador && parseEntityId(exportador)

    const funct = cuitExportador
      ? movimientosExportador.getTransferenciasPorExportador(cuitExportador)
      : movimientosExportador.getTransferenciasExportador()

    const titulo = 'Transferencias entre exportadores'

    funct
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          titulo,
          data,
          COLUMNAS.TRANSFERENCIAS_EXP_TO_PRINT,
          'landscape'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_TRANSFERENCIAS_EXP,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px'
            }
          },
          id: TABLAS.TABLA_TRANSFERENCIAS_EXPORTADOR
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function deleteTransferenciaExportadores (id) {
  return async (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_TRANSFERENCIAS_EXPORTADOR)(state)
    const exportadorListado = formValues.exportadorBusqueda
    dispatch({ type: 'DELETE_TRANSFERENCIA' })
    try {
      const result = await movimientosExportador.deleteTransferencia(id)
      if (!result.error) {
        toast.success('La transferencia entre exportadores se eliminó correctamente')
        dispatch(obtenerTransferenciasExportadores(exportadorListado))
      }
    } catch (error) {
      console.log(error)
      toast.error('Error al intentar eliminar la transferencia entre exportadores')
    }
  }
}

export function updateTransferenciaExportadores (id) {
  return (dispatch, getState) => {
    dispatch({ type: 'UPDATE_TRANSFERENCIA' })
    const state = getState()
    const formValues = getFormValues(FORM_TRANSFERENCIAS_EXPORTADOR)(state)
    const exportadorListado = formValues.exportadorBusqueda
    return movimientosExportador.updateTransferenciaExportadores(id, formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('La transferencia entre exportadores se actualizó correctamente')
          dispatch(obtenerTransferenciasExportadores(exportadorListado))
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar actualizar la transferencia entre exportadores')
      })
  }
}

export function obtenerDatosTabla (tablaId, titulo, funct, columnas, columnasToPrint, orientacionPdf) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    funct()
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          titulo,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerReconocimientoStock () {
  return (dispatch) => {
    return dispatch(obtenerDatosTabla(
      TABLAS.TABLA_RECONOCIMIENTO_STOCK,
      'Últimos reconocimientos de stock de la Terminal',
      stockListado.getReconocimientoStock,
      COLUMNAS.COL_RECONOCIMIENTO,
      COLUMNAS.RECONOCIMIENTO_TO_PRINT,
      'landscape'
    ))
  }
}

export function obtenerStockPresuntoTerminal () {
  return (dispatch) => {
    return dispatch(obtenerDatosTabla(
      TABLAS.TABLA_STOCK_PRESUNTO_TERMINAL,
      'Stock presunto: total de mermas acumuladas',
      stockListado.getStockPresuntoTerminal,
      COLUMNAS.COL_STOCK_PRESUNTO,
      COLUMNAS.STOCK_PRESUNTO_TO_PRINT,
      'landscape'
    ))
  }
}

export function obtenerIndices () {
  return (dispatch) => {
    return dispatch(obtenerDatosTabla(
      TABLAS.TABLA_STOCK_INDICES,
      'Estimacion anual de indices de merma de calidad',
      stockListado.getIndices,
      COLUMNAS.COL_INDICES,
      COLUMNAS.INDICES_TO_PRINT,
      'landscape'
    ))
  }
}

//* * Tablas de mercaderia stock */

export function actualizarDatosTabla (
  tablaId,
  columnas,
  columnasToPrint,
  funct,
  titulo,
  tituloPdf,
  orientacionPdf,
  fechaDesde,
  fechaHasta,
  saveFechas,
  exportador = null,
  cereal = null
) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    dispatch({ type: saveFechas, fechaD, fechaH })

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    const tituloPdfDescarga = `${tituloPdf} ${fechaConsulta}`

    funct(fechaD, fechaH, exportador, cereal)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdfDescarga,
          data,
          columnasToPrint,
          orientacionPdf
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px'
              // withGroup: withGroup,
              // groupByColumn: groupByColumn,
              // calculateTotalsGroup: calculateTotalsGroup
            }
          },
          id: tablaId
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerCosultaPorCosecha (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_CONSULTA_POR_COSECHA,
      COLUMNAS.COL_COSECHA,
      COLUMNAS.COSECHA_TO_PRINT,
      stockListado.getConsultaPorCosecha,
      ' ',
      'Consulta por cosecha',
      'portrait',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerMercaderiaFumigada (fechaDesde, fechaHasta) {
  return (dispatch) => {
    // const withGroup = true
    // const calculateTotalsGroup = ['netoTotalCamiones']
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MERCADERIA_FUMIGADA,
      COLUMNAS.COL_MERCADERIA_FUMIGADA,
      COLUMNAS.FUMIGADA_TO_PRINT,
      stockListado.getTotalizadorMercaderiaFumigada,
      'Mercaderia fumigada',
      'Liquidacion mercaderia fumigada',
      'portrait',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerMercaderiaSecada (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MERCADERIA_SECADA,
      COLUMNAS.COL_MERCADERIA_SECADA,
      COLUMNAS.SECADA_TO_PRINT,
      stockListado.getTotalizadorMercaderiaSecada,
      'Mercaderia secada',
      'Liquidacion mercaderia secada',
      'portrait',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerMercaderiaSecadaDosMas (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MERCADERIA_SECADA_DOS_MAS,
      COLUMNAS.COL_MERCADERIA_SECADA_2_MAS,
      COLUMNAS.SECADA_MAS_2_TO_PRINT,
      stockListado.getMercaderiaSecadaDosMasTotal,
      'Mercaderia secada +2%',
      'Liquidación mercaderia secada +2%',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerDescargaPorGrado (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_DESCARGA_POR_GRADO,
      COLUMNAS.COL_DESCARGA_POR_GRADO,
      COLUMNAS.DESCARGA_POR_GRADO_TO_PRINT,
      stockListado.getDescargaPorGradoTotal,
      'Descarga total por grado a liquidar según CACBA',
      'Descarga total por grado a liquidar según CACBA',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_STOCK_POR_GRADO'
    ))
  }
}

export function obtenerMercaderiaGrado3 (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_MERCADERIA_GRADO_3,
      COLUMNAS.COL_MERCADERIA_GRADO_3,
      COLUMNAS.MERCADERIA_GRADO_3_TO_PRINT,
      stockListado.getDescargaGrado3Total,
      'Descarga total de grado 3 según CACBA ',
      'Descarga total de grado 3 según CACBA ',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_STOCK_POR_GRADO'
    ))
  }
}

export function obtenerDescargaFueraDeGrado (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_FUERA_DE_GRADO,
      COLUMNAS.COL_MERCADERIA_FUERA_GRADO,
      COLUMNAS.MERCADERIA_FUERA_GRADO_TO_PRINT,
      stockListado.getLiquidacionFueraDeGrado,
      'Descarga total fuera de grado según CACBA ',
      'Descarga total fuera de grado según CACBA ',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_STOCK_POR_GRADO'
    ))
  }
}

export function obtenerMercaderiaRebajaAdicional (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MERCADERIA_REBAJA_ADICIONAL,
      COLUMNAS.COL_MERCADERIA_REBAJA_ADICIONAL,
      COLUMNAS.MERCADERIA_REBAJA_ADICIONAL_TO_PRINT,
      stockListado.getMercaderiaRebajaAdicional,
      'Mercaderia con rebaja adicional',
      'Mercaderia con rebaja adicional',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerMovimientosExportadores (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_MOVIMIENTOS_EXPORTADOR,
      COLUMNAS.COL_MOVIMIENTOS_EXPORTADOR,
      COLUMNAS.MOVIMIENTOS_EXPORTADOR_TO_PRINT,
      stockListado.getMovimientosExportadores,
      'Movimientos de mercadería exportadores',
      'Movimientos de mercadería exportadores',
      'landscape',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerTotalAlmacenaje (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_ALMACENAJE,
      COLUMNAS.COL_TOTAL_ALMACENAJE,
      COLUMNAS.TOTAL_ALMACENAJE_TO_PRINT,
      stockListado.getTotalAlmacenaje,
      'Total almacenaje de mercadería',
      'Total almacenaje de mercadería',
      'portrait',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA',
      exportador,
      cereal
    ))
  }
}

export function obtenerTotalZarandeo (fechaDesde, fechaHasta) {
  return (dispatch) => {
    return dispatch(actualizarDatosTabla(
      TABLAS.TABLA_TOTAL_ZARANDEO,
      COLUMNAS.COL_TOTAL_ZARANDEO,
      COLUMNAS.TOTAL_ZARANDEO_TO_PRINT,
      stockListado.getTotalZarandeo,
      'Total de mercadería zarandeada',
      'Total de mercadería zarandeada',
      'portrait',
      fechaDesde,
      fechaHasta,
      'ACTUALIZAR_FECHA_CONSULTA_MERCADERIA'
    ))
  }
}

export function obtenerAlmacenajeEspecial (fechaDesde, fechaHasta, cereal) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_ALMACENAJE_ESPECIAL
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')

    const fechaConsulta = (fechaD === fechaH)
      ? ` del dia ${moment(fechaD).format('DD-MM-YYYY')}`
      : ` entre el ${moment(fechaD).format('DD-MM-YYYY')} y el ${moment(fechaH).format('DD-MM-YYYY')}`

    const titulo = 'Almacenaje especial'
    const tituloPdfDescarga = `${titulo} ${fechaConsulta}`

    stockListado.getAlmacenajeEspecial(fechaD, fechaH, cereal)
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdfDescarga,
          data,
          COLUMNAS.ALMACENAJE_ESPECIAL_TO_PRINT,
          'portrait'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.getColumnasAlmacenajeEspecial(fechaD, fechaH, fechaConsulta),
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLAS.TABLA_ALMACENAJE_ESPECIAL
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

//* * Tablas de detalles de listados de facturacion */
export function actualizarDatosTablaDetalles (
  tablaId,
  columnas,
  columnasToPrint,
  funct,
  titulo,
  tituloPdf,
  orientacionPdf,
  exportador,
  cereal,
  fechaDesde,
  fechaHasta = null,
  variedad = null,
  showRowCount = true,
  textRowCount = 'Cantidad de camiones: '
) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    const fechaD = moment(fechaDesde).format('DD-MM-YYYY')
    const fechaH = moment(fechaHasta).format('DD-MM-YYYY') || null

    funct(fechaD, exportador, cereal, fechaH && fechaH, variedad && variedad)
      .then((d) => {
        const data = d.data
        const variedadConsulta = (variedad && variedad.trim() !== 'UNDEF') ? `${variedad} - ` : ' '
        const descripcion = `${cereal} - ${variedadConsulta} ${exportador}`
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf,
          descripcion
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px',
              showRowCount,
              textRowCount
            }
          },
          id: tablaId
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarDetalleMercaderiaFumigada (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_MERCADERIA_FUMIGADA,
      COLUMNAS.COL_DETALLE_MERCADERIA_FUMIGADA,
      COLUMNAS.DETALLE_FUMIGADA_TO_PRINT,
      stockListado.getMercaderiaFumigada,
      'Detalle de mercaderia fumigada',
      'Liquidación mercaderia fumigada',
      'portrait',
      exportador,
      cereal,
      fechaDesde,
      fechaHasta
    ))
  }
}

export function actualizarDetalleMercaderiaSecada (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_MERCADERIA_SECADA,
      COLUMNAS.COL_DETALLE_MERCADERIA_SECADA,
      COLUMNAS.DETALLE_SECADA_TO_PRINT,
      stockListado.getMercaderiaSecada,
      'Detalle de mercaderia secada',
      'Liquidación mercaderia secada',
      'portrait',
      exportador,
      cereal,
      fechaDesde,
      fechaHasta
    ))
  }
}

export function actualizarMovDiariosExp (fechaDesde, fechaHasta, exportador, cereal, total) {
  return (dispatch) => {
    const rowCount = false
    const tituloPdf = `Detalle movimientos diarios exportador | Total: ${total.toLocaleString('es-ES')} kg.`
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_MOVIMIENTOS_DIARIOS_EXP,
      COLUMNAS.COL_DETALLE_MOV_EXP,
      COLUMNAS.DETALLE_MOV_EXP_TO_PRINT,
      movimientosExportador.getMovimientosDiarioExportador,
      'Detalle movimientos diarios exportador',
      tituloPdf,
      'portrait',
      exportador,
      cereal,
      fechaDesde,
      fechaHasta,
      null,
      rowCount
    ))
  }
}

export function obtenerDetalleSecadaDosMas (fecha, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_SECADA_2_MAS,
      COLUMNAS.COL_DETALLE_SECADA_2_MAS,
      COLUMNAS.DETALLE_SECADA_2_MAS_TO_PRINT,
      stockListado.getDetalleMercaderiaSecadaDosMas,
      'Detalle de mercaderia secada +2%',
      'Liquidación mercaderia secada +2%',
      'landscape',
      exportador,
      cereal,
      fecha
    ))
  }
}

export function obtenerDetalleDescargaPorGrado (fechaD, fechaH, exportador, cereal, variedad) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_DESCARGA_POR_GRADO,
      COLUMNAS.COL_DETALLE_DESCARGA_POR_GRADO,
      COLUMNAS.DETALLE_POR_GRADO_TO_PRINT,
      stockListado.getDetalleDescargaPorGrado,
      'Detalle de descarga por grado según CACBA',
      'Detalle descarga por grado según CACBA',
      'landscape',
      exportador,
      cereal,
      fechaD,
      fechaH,
      variedad
    ))
  }
}

export function obtenerDetalleMovimientoExp (fechaD, fechaH, exportador, cereal, variedad) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_MOVIMIENTOS_EXP,
      COLUMNAS.COL_DETALLE_MOVIMIENTO_EXP,
      COLUMNAS.DETALLE_MOVI_EXP_TO_PRINT,
      stockListado.getDetalleMovimientosExportadores,
      'Detalle movimientos diarios exportador',
      'Detalle movimientos diarios exportador',
      'landscape',
      exportador,
      cereal,
      fechaD,
      fechaH,
      variedad
    ))
  }
}

export function obtenerDetalleMercaderiaGrado3 (fechaD, fechaH, exportador, cereal, variedad) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_DESCARGA_GRADO_3,
      COLUMNAS.COL_DETALLE_GRADO_3,
      COLUMNAS.COL_DETALLE_GRADO_3_TO_PRINT,
      stockListado.getDetalleMercaderiaGrado3,
      'Detalle descarga de grado 3 según CACBA',
      'Detalle descarga de grado 3 según CACBA',
      'landscape',
      exportador,
      cereal,
      fechaD,
      fechaH,
      variedad
    ))
  }
}

export function obtenerDetalleFueraDeGrado (fechaD, fechaH, exportador, cereal, variedad) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_FUERA_DE_GRADO,
      COLUMNAS.COL_DETALLE_FUERA_DE_GRADO,
      COLUMNAS.DETALLE_FUERA_DE_GRADO_TO_PRINT,
      stockListado.getDetalleFueraDeGrado,
      'Detalle descarga fuera de estandar según CACBA',
      'Detalle descarga fuera de grado según CACBA',
      'landscape',
      exportador,
      cereal,
      fechaD,
      fechaH,
      variedad
    ))
  }
}

export function actualizarDatoCambioCerealExportador (fechaDesde, fechaHasta, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_CAMBIOS_CEREAL_EXPORTADOR,
      COLUMNAS.COL_CAMBIO_CEREAL_EXPORTADOR,
      COLUMNAS.CAMBIO_CEREAL_EXPORTADOR_TO_PRINT,
      stockListado.getCambiosCerealExportador,
      'Cambios de cereal por exportador',
      'Cambios de cereal por exportador',
      'portrait',
      exportador,
      cereal,
      fechaDesde,
      fechaHasta
    ))
  }
}

export function obtenerDetalleAlmacenajeEspecial (fechaD, fechaH, exportador, cereal, stockTotal) {
  return (dispatch) => {
    const tituloPdf = `Detalle almacenaje especial de mercaderia - Stock: ${stockTotal.toLocaleString('es-ES')} kg.`
    const showRowCount = false
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_ALMACENAJE_ESPECIAL,
      COLUMNAS.COL_DETALLE_ALMACENAJE_ESPECIAL,
      COLUMNAS.DETALLE_ALMACENAJE_ESP_TO_PRINT,
      stockListado.getDetalleAlmacenajeEspecial,
      'Detalle diario almacenaje especial de mercaderia',
      tituloPdf,
      'portrait',
      exportador,
      cereal,
      fechaD,
      fechaH,
      null,
      showRowCount
    ))
  }
}

export function obtenerDetalleZarandeo (fecha, exportador, cereal) {
  return (dispatch) => {
    return dispatch(actualizarDatosTablaDetalles(
      TABLAS.TABLA_DETALLE_ZARANDEO,
      COLUMNAS.COL_DETALLE_ZARANDEO,
      COLUMNAS.DETALLE_ZARANDEO_TO_PRINT,
      stockListado.getDetalleZarandeo,
      'Detalle mercaderia con zaranzadeo',
      'Detalle mercaderia con zaranzadeo',
      'portrait',
      exportador,
      cereal,
      fecha
    ))
  }
}

//* * Tablas de detalles de listados de facturacion */
export function actualizarDatos (
  tablaId,
  columnas,
  columnasToPrint,
  funct,
  titulo,
  tituloPdf,
  orientacionPdf,
  valores,
  showRowCount = true,
  textRowCount = 'Cantidad de camiones: '
) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: tablaId
    })

    funct(valores)
      .then((d) => {
        const data = d

        const cereal = valores.cereal || ' '
        const exportador = valores.exportador
        const variedad = valores.variedad || ' '

        const variedadConsulta = (variedad.trim() !== 'UNDEF') ? `${variedad} - ` : ' '
        const descripcion = `${cereal} - ${variedadConsulta} ${exportador}`
        const customToolbar = pdfCustomToolbarGenerator(
          tituloPdf,
          data,
          columnasToPrint,
          orientacionPdf,
          descripcion
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: columnas,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px',
              showRowCount,
              textRowCount
            }
          },
          id: tablaId
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerDetallePorCosecha (fechaDesde, fechaHasta, cereal, cosecha, variedad) {
  return (dispatch) => {
    const valores = {
      fechaDesde,
      fechaHasta,
      cereal,
      cosecha,
      variedad
    }
    return dispatch(actualizarDatos(
      TABLAS.TABLA_DETALLE_CONSULTA_POR_COSECHA,
      COLUMNAS.COL_DETALLE_COSECHA,
      COLUMNAS.DETALLE_COSECHA_TO_PRINT,
      stockListado.getDetalleConsultaPorCosecha,
      'Detalle descarga por cosecha',
      'Detalle descarga por cosecha',
      'portrait',
      valores
    ))
  }
}

export function obtenerVentasAExportadorActual () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_VENTA_A_EXPORTADOR_ACTUAL
    })

    const titulo = 'Ventas a exportador del ejercicio actual'
    movimientosTerminal.getVentasAExportadorActual()
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          titulo,
          data,
          COLUMNAS.VENTAS_A_EXPORTADOR_ACTUAL_TO_PRINT,
          'portrait'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_VENTAS_A_EXPORTADOR_ACTUAL,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLAS.TABLA_VENTA_A_EXPORTADOR_ACTUAL
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerRankingExportadores () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLAS.TABLA_RANKING_EXPORTADORES
    })

    const titulo = 'Ranking exportadores'
    stockListado.getRankingExportadores()
      .then((d) => {
        const data = parseData(d)
        const customToolbar = pdfCustomToolbarGenerator(
          titulo,
          data,
          COLUMNAS.RANKING_EXPORTADORES_TO_PRINT,
          'portrait'
        )
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNAS.COL_RANKING_EXPORTADORES,
            data: data,
            title: titulo,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLAS.TABLA_RANKING_EXPORTADORES
        })
      })

      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}
